/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for a check appointment duration
 * @export
 * @interface CheckAppointmentDurationResponse
 */
export interface CheckAppointmentDurationResponse {
    /**
     * warning code if check is not ok
     * @type {string}
     * @memberof CheckAppointmentDurationResponse
     */
    warningCode?: CheckAppointmentDurationResponseWarningCodeEnum;
}


/**
 * @export
 */
export const CheckAppointmentDurationResponseWarningCodeEnum = {
    TooLong: 'TOO_LONG',
    NoTimeSlotForApptTypeMsg: 'NO_TIME_SLOT_FOR_APPT_TYPE_MSG'
} as const;
export type CheckAppointmentDurationResponseWarningCodeEnum = typeof CheckAppointmentDurationResponseWarningCodeEnum[keyof typeof CheckAppointmentDurationResponseWarningCodeEnum];


/**
 * Check if a given object implements the CheckAppointmentDurationResponse interface.
 */
export function instanceOfCheckAppointmentDurationResponse(value: object): value is CheckAppointmentDurationResponse {
    return true;
}

export function CheckAppointmentDurationResponseFromJSON(json: any): CheckAppointmentDurationResponse {
    return CheckAppointmentDurationResponseFromJSONTyped(json, false);
}

export function CheckAppointmentDurationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckAppointmentDurationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'warningCode': json['warningCode'] == null ? undefined : json['warningCode'],
    };
}

export function CheckAppointmentDurationResponseToJSON(json: any): CheckAppointmentDurationResponse {
    return CheckAppointmentDurationResponseToJSONTyped(json, false);
}

export function CheckAppointmentDurationResponseToJSONTyped(value?: CheckAppointmentDurationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warningCode': value['warningCode'],
    };
}

